import type { RouteObject } from 'react-router'
import type { CallCenterFeature } from '@/features/call-center'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import {
  createCallCenterJobPageLoader,
  createCallCenterViewLoader,
} from '@/features/call-center/call-center-route-loaders'

/**
 * Options for {@link createRoutes}.
 */
export interface CreateCallCenterRoutesOptions {
  callCenter: CallCenterFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates routes for the call center feature.
 */
export function createRoutes(
  options: CreateCallCenterRoutesOptions,
): RouteObject[] {
  return [
    {
      path: '/call-center',
      loader: createCallCenterViewLoader(options),
      lazy: {
        Component: () =>
          import('@/features/call-center/CallCenter/CallCenterContainer').then(
            (r) => r.default,
          ),
      },
      children: [
        {
          index: true,
          lazy: {
            Component: () =>
              import('@/features/call-center/CallCenter/CallCenterLookupPageContainer').then(
                (r) => r.default,
              ),
          },
        },
        {
          path: ':jobId',
          loader: createCallCenterJobPageLoader(options),
          lazy: {
            Component: () =>
              import('@/features/call-center/CallCenter/CallCenterJobPageContainer').then(
                (r) => r.default,
              ),
          },
          children: [
            {
              index: true,
              lazy: {
                Component: () =>
                  import('@/features/call-center/CallCenter/CallCenterJobSectionPageContainer').then(
                    (r) => r.default,
                  ),
              },
            },
            {
              path: 'checkout',
              lazy: {
                Component: () =>
                  import('@/features/call-center/CallCenter/CallCenterCheckoutPageContainer').then(
                    (r) => r.default,
                  ),
              },
            },
          ],
        },
      ],
    },
  ]
}
